import React from 'react'

import { backgroundStyles, ButtonAppearance } from '../Form'
import { IconDefinition } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as Indicators from '../Indicators'
import { concatStyles } from 'utils'

const ROUND_BUTTON_STYLES =
  'flex justify-center items-center hover:bg-opacity-75 border-0 rounded-full cursor-pointer text-contentareabackground w-8 h-8'

export type IconButtonAppearance = 'primary' | 'secondary' | 'destructive'
export interface IconButtonProps {
  color?: string | null
  onClick?: (e?: React.MouseEvent) => void | Promise<void>
  loading?: boolean
  icon: IconDefinition
  appearance?: ButtonAppearance
  className?: string
  style?: React.CSSProperties
}

export const IconButton: React.FC<IconButtonProps> = ({
  icon,
  onClick,
  loading,
  appearance = 'primary',
  style,
  className,
}) => {
  const handleClick: React.MouseEventHandler<HTMLButtonElement> = (e) => {
    e.preventDefault()
    e.stopPropagation()
    onClick && onClick(e)
  }

  return (
    <button
      className={concatStyles([
        ROUND_BUTTON_STYLES,
        backgroundStyles(appearance),
        className,
      ])}
      onClick={handleClick}
      style={style}
    >
      {loading ? (
        <Indicators.Spinner className="m-auto" />
      ) : (
        <FontAwesomeIcon icon={icon} size="1x" />
      )}
    </button>
  )
}
